var _path;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
var SvgClose = function SvgClose(_ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    fill: "currentColor",
    viewBox: "0 0 24 24",
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M16.95 7.05c-.44-.44-1.06-.353-1.414 0L12 10.586 8.464 7.05c-.353-.353-1.06-.353-1.414 0-.353.354-.353 1.06 0 1.414L10.586 12 7.05 15.536c-.353.353-.353 1.06 0 1.414.354.353 1.06.353 1.414 0L12 13.414l3.536 3.536c.353.353 1.06.353 1.414 0 .353-.354.353-1.06 0-1.414L13.414 12l3.536-3.536c.353-.353.44-.974 0-1.414",
    clipRule: "evenodd"
  })));
};
export { SvgClose as ReactComponent };
export default __webpack_public_path__ + "static/media/close.ccc5c7532105b0cd3f4c99353750e281.svg";